export const Dollar = 'Dollar';
export const Share = 'Share';